import { AbpHttpInterceptor, RefreshTokenService, AbpHttpConfigurationService } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import * as ApiServiceProxies from './service-proxies';
import { ZeroRefreshTokenService } from '@account/auth/zero-refresh-token.service';
import { ZeroTemplateHttpConfigurationService } from './zero-template-http-configuration.service';
import { ZeroTemplateHttpInterceptor } from './zero-template-http-interceptor';

// The generated proxies are not providedIn: 'root'. Register all of them here so
// standalone/lazy-loaded pages can inject both template and application proxies.
export const SERVICE_PROXY_PROVIDERS = [
    ApiServiceProxies.AccountServiceProxy,
    ApiServiceProxies.ActiveDirectoryWidgetsServiceProxy,
    ApiServiceProxies.AdvancedPieChartServiceProxy,
    ApiServiceProxies.ArchiveProgressServiceProxy,
    ApiServiceProxies.ArchivingSourceSummaryWidgetsServiceProxy,
    ApiServiceProxies.AuditLogServiceProxy,
    ApiServiceProxies.CachingServiceProxy,
    ApiServiceProxies.ChatServiceProxy,
    ApiServiceProxies.CommonLookupServiceProxy,
    ApiServiceProxies.CredentialServiceProxy,
    ApiServiceProxies.DashboardCustomizationServiceProxy,
    ApiServiceProxies.DemoUiComponentsServiceProxy,
    ApiServiceProxies.DomainsServiceProxy,
    ApiServiceProxies.DomainUsersServiceProxy,
    ApiServiceProxies.DynamicEntityPropertyServiceProxy,
    ApiServiceProxies.DynamicEntityPropertyDefinitionServiceProxy,
    ApiServiceProxies.DynamicEntityPropertyValueServiceProxy,
    ApiServiceProxies.DynamicPropertyServiceProxy,
    ApiServiceProxies.DynamicPropertyValueServiceProxy,
    ApiServiceProxies.EditionServiceProxy,
    ApiServiceProxies.EmailTemplatesServiceProxy,
    ApiServiceProxies.EndpointsServiceProxy,
    ApiServiceProxies.EnterpriseVaultWidgetsServiceProxy,
    ApiServiceProxies.EntityChangeServiceProxy,
    ApiServiceProxies.EVArchivesServiceProxy,
    ApiServiceProxies.EVDirectoriesServiceProxy,
    ApiServiceProxies.EVFailedItemManagementServiceProxy,
    ApiServiceProxies.ExchangeDatabasesServiceProxy,
    ApiServiceProxies.ExchangeEndpointsServiceProxy,
    ApiServiceProxies.ExchangeServersServiceProxy,
    ApiServiceProxies.ExchangeWidgetsServiceProxy,
    ApiServiceProxies.ExternalLoginLinkServiceProxy,
    ApiServiceProxies.FileSharesServiceProxy,
    ApiServiceProxies.FriendshipServiceProxy,
    ApiServiceProxies.HealthCheckServiceProxy,
    ApiServiceProxies.HostDashboardServiceProxy,
    ApiServiceProxies.HostSettingsServiceProxy,
    ApiServiceProxies.InstallServiceProxy,
    ApiServiceProxies.InvoiceServiceProxy,
    ApiServiceProxies.JournalFinishedServiceProxy,
    ApiServiceProxies.JournalProgressServiceProxy,
    ApiServiceProxies.LanguageServiceProxy,
    ApiServiceProxies.MailArchiveJournalMappingServiceProxy,
    ApiServiceProxies.MailArchiveLeaversMappingServiceProxy,
    ApiServiceProxies.MailArchiveMappingSelectionServiceProxy,
    ApiServiceProxies.MailArchiveMigrationMappingServiceProxy,
    ApiServiceProxies.MailArchivesFinishedServiceProxy,
    ApiServiceProxies.MailboxesServiceProxy,
    ApiServiceProxies.MigrationProcessServiceProxy,
    ApiServiceProxies.MigrationProcessWidgetsServiceProxy,
    ApiServiceProxies.MigrationProgressServiceProxy,
    ApiServiceProxies.MLXEndpointsServiceProxy,
    ApiServiceProxies.MLXMailboxesServiceProxy,
    ApiServiceProxies.MlxMappingSelectionServiceProxy,
    ApiServiceProxies.MLXMigrationProcessServiceProxy,
    ApiServiceProxies.MLXMigrationProgressesServiceProxy,
    ApiServiceProxies.MLXServersServiceProxy,
    ApiServiceProxies.MLXUserMailboxFinishedServiceProxy,
    ApiServiceProxies.MLXUserMailboxMappingSelectionServiceProxy,
    ApiServiceProxies.ModulePoolsServiceProxy,
    ApiServiceProxies.ModulesServiceProxy,
    ApiServiceProxies.ModuleStatisticsServiceProxy,
    ApiServiceProxies.ModuleToVaultStoreServiceProxy,
    ApiServiceProxies.NotificationServiceProxy,
    ApiServiceProxies.OnboardMappingSelectionServiceProxy,
    ApiServiceProxies.OnpremServicesServiceProxy,
    ApiServiceProxies.OnPremWidgetsServiceProxy,
    ApiServiceProxies.OrganizationUnitServiceProxy,
    ApiServiceProxies.OverviewServiceProxy,
    ApiServiceProxies.PaymentServiceProxy,
    ApiServiceProxies.PayPalPaymentServiceProxy,
    ApiServiceProxies.PermissionServiceProxy,
    ApiServiceProxies.ProfileServiceProxy,
    ApiServiceProxies.ProgressServiceProxy,
    ApiServiceProxies.PstFilesServiceProxy,
    ApiServiceProxies.PstOutputsServiceProxy,
    ApiServiceProxies.QAMEndpointsServiceProxy,
    ApiServiceProxies.QAMMailboxesServiceProxy,
    ApiServiceProxies.QAMMailStoresServiceProxy,
    ApiServiceProxies.QamMappingSelectionServiceProxy,
    ApiServiceProxies.QAMMigrationProcessServiceProxy,
    ApiServiceProxies.QAMMigrationProgressesServiceProxy,
    ApiServiceProxies.QAMUserMailboxFinishedServiceProxy,
    ApiServiceProxies.QAMUserMailboxMappingSelectionServiceProxy,
    ApiServiceProxies.RateLimitPolicyServiceProxy,
    ApiServiceProxies.RetentionMappingServiceProxy,
    ApiServiceProxies.RoleServiceProxy,
    ApiServiceProxies.SessionServiceProxy,
    ApiServiceProxies.SharedArchiveMappingSelectionServiceProxy,
    ApiServiceProxies.SMTPServersServiceProxy,
    ApiServiceProxies.SourceOneArchiveConnectionsServiceProxy,
    ApiServiceProxies.SourceOneArchiveProgressServiceProxy,
    ApiServiceProxies.SourceOneArchivesServiceProxy,
    ApiServiceProxies.SourceOneEndpointsServiceProxy,
    ApiServiceProxies.SourceOneFailedItemManagementServiceProxy,
    ApiServiceProxies.SourceOneJournalFinishedServiceProxy,
    ApiServiceProxies.SourceOneJournalMappingServiceProxy,
    ApiServiceProxies.SourceOneJournalProgressServiceProxy,
    ApiServiceProxies.SourceOneLeaversMappingServiceProxy,
    ApiServiceProxies.SourceOneMigrationProcessServiceProxy,
    ApiServiceProxies.SourceOneProgressesServiceProxy,
    ApiServiceProxies.SourceOneUserMailboxMappingSelectionServiceProxy,
    ApiServiceProxies.SourceOneWidgetsServiceProxy,
    ApiServiceProxies.StagingCachesServiceProxy,
    ApiServiceProxies.StripePaymentServiceProxy,
    ApiServiceProxies.SubscriptionServiceProxy,
    ApiServiceProxies.TenantServiceProxy,
    ApiServiceProxies.TenantCustomizationServiceProxy,
    ApiServiceProxies.TenantDashboardServiceProxy,
    ApiServiceProxies.TenantRegistrationServiceProxy,
    ApiServiceProxies.TenantSettingsServiceProxy,
    ApiServiceProxies.TimingServiceProxy,
    ApiServiceProxies.TokenAuthServiceProxy,
    ApiServiceProxies.TwitterServiceProxy,
    ApiServiceProxies.UiCustomizationSettingsServiceProxy,
    ApiServiceProxies.UserServiceProxy,
    ApiServiceProxies.UserDelegationServiceProxy,
    ApiServiceProxies.UserLinkServiceProxy,
    ApiServiceProxies.UserLoginServiceProxy,
    ApiServiceProxies.UserSessionServiceProxy,
    ApiServiceProxies.VaultStoresServiceProxy,
    ApiServiceProxies.WebhookEventServiceProxy,
    ApiServiceProxies.WebhookSendAttemptServiceProxy,
    ApiServiceProxies.WebhookSubscriptionServiceProxy,
    ApiServiceProxies.WebLogServiceProxy,
    ApiServiceProxies.WidgetChartsServiceProxy,
    { provide: RefreshTokenService, useClass: ZeroRefreshTokenService },
    { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
    { provide: HTTP_INTERCEPTORS, useClass: ZeroTemplateHttpInterceptor, multi: true },
];
